import { CustomTabs } from '@lfg/ui/components';
import { Box } from '@mui/material';
import { useMemo, useState } from 'react';

import { ProjectThemeTabs } from 'src/global/enums/project.enum';
import { colors } from 'src/global/styles/colors';

import { ImageSection } from './ImageSection/ImageSection';
import { TextSection } from './TextSection/TextSection';
import { ThemeSection } from './ThemeSection/ThemeSection';

enum Tab {
  THEME = 'THEME',
  TEXT = 'TEXT',
  IMAGES = 'IMAGES',
}

export function ThemeEditorTabs() {
  const [activeTab, setActiveTab] = useState<Tab>(Tab.THEME);

  const themeEditorTabs = useMemo(
    () => [
      {
        label: 'Theme',
        value: ProjectThemeTabs.THEME,
        icon: <img src='/icons/common/theme.svg' width={24} height={24} alt='theme' />,
        content: <ThemeSection />,
      },
      {
        label: 'Text',
        value: ProjectThemeTabs.TEXT,
        icon: <img src='/icons/common/text.svg' width={24} height={24} alt='text' />,
        content: (
          <Box>
            <TextSection />
          </Box>
        ),
      },
      {
        label: 'Images',
        value: ProjectThemeTabs.IMAGES,
        icon: <img src='/icons/common/gallery.svg' width={24} height={24} alt='img' />,
        content: (
          <Box>
            <ImageSection />
          </Box>
        ),
      },
    ],
    [],
  );
  return (
    <Box
      width={'100%'}
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
      }}>
      <CustomTabs
        wrapperProps={{
          sx: {
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
          },
        }}
        tabs={themeEditorTabs}
        value={activeTab}
        sx={{
          padding: '8px',
          width: '133px',
        }}
        tabProps={{
          sx: {
            borderRadius: '4px',
            color: 'white',
            textTransform: 'none',
            display: 'flex',
            gap: '4px',
            flexDirection: 'column',
            '&.Mui-selected': {
              color: 'white',
              backgroundColor: `${colors.neutral06} !important`,
              border: 'none',
            },
          },
        }}
        TabIndicatorProps={{
          sx: {
            display: 'none',
          },
        }}
        contentProps={{
          sx: {
            width: '-webkit-fill-available',
            borderLeft: `1px solid ${colors.neutral015}`,
          },
        }}
        orientation='vertical'
        onChange={(_, newValue) => setActiveTab(newValue as Tab)}
      />
    </Box>
  );
}
